export const kaufland = {
  clientId: "Client-Key",
  clientSecret: "Secret-Key",
  clientIdHelp:
    "Der Client-Key ist im Kaufland Seller Portal unter Einstellungen > API zu finden (https://sellerportal.kaufland.de/settings/api).",
  clientSecretHelp:
    "Der Secret-Key ist im Kaufland Seller Portal unter Einstellungen > API zu finden (https://sellerportal.kaufland.de/settings/api).",
  storefront: "Storefront",
  storefrontHelp: "Kaufland Storefront (Land) für diese Integration auswählen."
};
